"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _user = require("@/api/user");
var _memberManage = require("@/api/_homeCloudPlatform/member/memberManage.js");
var _org = require("@/api/org");
var _role = require("@/api/role");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _file = require("@/api/file");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
var _xlsx = _interopRequireDefault(require("xlsx"));
var _fileSaver = _interopRequireDefault(require("file-saver"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultUser = {
  name: '',
  username: '',
  dept: null,
  avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
  phone: '',
  roles: [],
  type: null,
  referrer: null,
  referrer_id: '',
  referrer_name: '',
  superior: null,
  home_account: '',
  home_account_name: ''
};
var phoneValidator = function phoneValidator(rule, value, callBack) {
  var reg = /^[1][0-9]{10}$/;
  if (value) {
    if (!reg.test(value)) {
      callBack('请输入正确的手机号码');
    } else {
      callBack();
    }
  } else {
    callBack();
  }
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      user: defaultUser,
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      userList: {
        count: 0
      },
      roles: [],
      dept: [],
      referrer: [],
      superior: [],
      saleType: false,
      noSaleType: false,
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 10
      },
      profitOptions: [{
        key: 1,
        display_name: '渠道商'
      }, {
        key: 2,
        display_name: '运维团队'
      }, {
        key: 3,
        display_name: '设备所属单位'
      }, {
        key: 4,
        display_name: 'C端机构'
      }, {
        key: 5,
        display_name: 'TTS专家工作室'
      }, {
        key: 6,
        display_name: 'TTS方案归属团队'
      }, {
        key: 10,
        display_name: '新汉方公司'
      }],
      typeOptions: [{
        key: 1,
        display_name: '管理员'
      }, {
        key: 2,
        display_name: '公司销售'
      }, {
        key: 3,
        display_name: '经销商'
      }],
      dialogVisible: false,
      dialogType: 'new',
      rule1: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }, {
          max: 20,
          message: '输入长度不能超过20位'
        }],
        username: [{
          required: true,
          message: '请输入账号',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          max: 11,
          message: '输入长度不能超过11位'
        }, {
          validator: phoneValidator
        }],
        roles: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }],
        dept: [{
          required: true,
          message: '请选择部门',
          trigger: 'blur'
        }],
        referrer_id: [{
          required: true,
          message: '请输入引荐人编码',
          trigger: 'blur'
        }],
        referrer_name: [{
          required: true,
          message: '非法人员请重新输入编码',
          trigger: 'blur'
        }],
        superior: [{
          required: true,
          message: '请选择上级',
          trigger: 'change'
        }],
        home_account: [{
          required: true,
          message: '请输入会员帐号',
          trigger: 'blur'
        }]
      },
      filterOrgText: '',
      treeLoding: false,
      orgData: [],
      selectVal: '',
      selectName: '',
      salesTypeOptions: [{
        key: 0,
        display_name: '销售部门'
      }, {
        key: 1,
        display_name: '非销售部门'
      }],
      table: [],
      count: '',
      superior1: '',
      referrer1: '',
      type1: '',
      rowData: [],
      user_id: '',
      password: ''
    };
  },
  computed: {},
  watch: {
    filterOrgText: function filterOrgText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.getList();
    this.getOrgAll();
    this.getRoleAll();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.user.avatar = process.env.VUE_APP_BASE_API + res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleOrgClick: function handleOrgClick(obj, node, vue) {
      this.listQuery.page = 1;
      this.listQuery.dept = obj.id;
      this.getList();
      this.selectVal = obj.name;
    },
    delVal: function delVal() {
      this.listQuery.dept = null;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.getUserList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.userList = response.data;
          _this.count = response.data.count;
          // this.getReferrer()
        }
        _this.listLoading = false;
      });
    },
    getOrgAll: function getOrgAll() {
      var _this2 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this2.orgData = (0, _utils.genTree)(response.data);
        _this2.treeLoding = false;
      });
    },
    getRoleAll: function getRoleAll() {
      var _this3 = this;
      (0, _role.getRoleAll)().then(function (response) {
        _this3.roles = (0, _utils.genTree)(response.data);
      });
    },
    getDept: function getDept() {
      var _this4 = this;
      console.log(this.user.roles);
      if (this.user.roles.length === 1) {
        (0, _role.getRole)(this.user.roles).then(function (response) {
          console.log(response.data.type);
          if (response.data.type === 1 || response.data.type === 3) {
            _this4.saleType = true;
            _this4.noSaleType = false;
            (0, _org.getOrgAll)({
              sales_type: 0
            }).then(function (response) {
              _this4.dept = (0, _utils.genTree)(response.data);
            });
          } else if (response.data.type === 2 || response.data.type === 4) {
            _this4.noSaleType = true;
            _this4.saleType = false;
            (0, _org.getOrgAll)({
              sales_type: 1
            }).then(function (response) {
              _this4.dept = (0, _utils.genTree)(response.data);
            });
          } else {
            _this4.noSaleType = false;
            _this4.saleType = false;
          }
        });
      } else {
        this.noSaleType = false;
        this.saleType = false;
        this.user.dept = null;
        this.user.referrer = null;
        this.user.referrer_name = '';
        this.user.superior = null;
      }
    },
    getPerson: function getPerson() {
      this.getSuperior();
    },
    getReferrer: function getReferrer() {
      var _this5 = this;
      (0, _user.getUserList)({
        page: 1,
        page_size: this.count
      }).then(function (response) {
        // const arr = response.data.results
        // console.log(arr)
        // for (let i = 0; i < arr.length; i++) {
        //   this.referrer[i] = arr[i].username
        // }
        _this5.referrer = response.data.results;
        console.log(_this5.referrer);
      });
    },
    getSuperior: function getSuperior() {
      var _this6 = this;
      (0, _user.getUserList)({
        dept: this.user.dept
      }).then(function (response) {
        _this6.superior = response.data.results;
      });
      console.log(this.superior);
    },
    getSaleName: function getSaleName() {
      var _this7 = this;
      console.log(this.user.referrer_id);
      if (this.user.referrer_id) {
        (0, _user.getUserList)({
          user_id: this.user.referrer_id
        }).then(function (response) {
          if (response.data.count === 1) {
            _this7.$set(_this7.user, 'referrer_name', response.data.results[0].name);
            _this7.$set(_this7.user, 'referrer', response.data.results[0].id);
          } else {
            _this7.$set(_this7.user, 'referrer_name', '');
            _this7.$set(_this7.user, 'referrer', '');
          }
        });
      } else {
        this.$set(this.user, 'referrer_name', '');
        this.$set(this.user, 'referrer', '');
      }
      console.log(this.user);
    },
    getHomeAccountName: function () {
      var _getHomeAccountName = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.user.home_account && this.user.home_account.length == 11)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return (0, _memberManage.getUsersList)({
                account: this.user.home_account
              }).then(function (response) {
                if (response.status_code === 200) {
                  if (response.count == 0) {
                    _this8.$message({
                      message: '无匹配会员信息，请再次确认',
                      type: 'warning'
                    });
                  } else {
                    _this8.$set(_this8.user, 'home_account_name', response.results[0].name);
                  }
                  // this.$set(this.user, 'referrer', response.data.results[0].id)
                } else {
                  _this8.$message({
                    message: '无匹配会员信息，请再次确认',
                    type: 'warning'
                  });
                  // this.$set(this.user, 'referrer', '')
                }
              });
            case 3:
              _context.next = 7;
              break;
            case 5:
              this.$message({
                message: '会员手机号格式错误，请再次确认',
                type: 'warning'
              });
              this.$set(this.user, 'home_account_name', '');
              // this.$set(this.user, 'referrer', '')
            case 7:
              console.log(this.user);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getHomeAccountName() {
        return _getHomeAccountName.apply(this, arguments);
      }
      return getHomeAccountName;
    }(),
    handleExport1: function handleExport1() {
      var xlsxParam = {
        raw: true
      };
      /* 从表生成工作簿对象 */
      var obj = _xlsx.default.utils.table_to_book(document.querySelector('#table'), xlsxParam);
      /* 获取二进制字符串作为输出 */
      var excel = _xlsx.default.write(obj, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      });
      try {
        _fileSaver.default.saveAs(
        // Blob 对象表示一个不可变、原始数据的类文件对象。
        // Blob 表示的不一定是JavaScript原生格式的数据。
        // File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
        // 返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
        new Blob([excel], {
          type: 'application/octet-stream'
        }),
        // 设置导出文件名称
        'user.xlsx');
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, excel);
      }
      return excel;
    },
    handleExport: function handleExport() {
      var _this9 = this;
      var excelData = [['ID', '编号', '姓名', '账户', '手机号码', '角色', '部门类型', '部门名称', '引荐人编号', '引荐人姓名', '上级编号', '上级姓名', '账户建立时间', '最后一次登录时间']];
      (0, _user.getUserList)({
        page: 1,
        page_size: this.count
      }).then(function (response) {
        _this9.table = response.data.results;
        for (var i = 0; i < _this9.table.length; i++) {
          _this9.rowData = [i + 1, _this9.table[i].user_id, _this9.table[i].name, _this9.table[i].username, _this9.table[i].phone, _this9.table[i].roles_name[0], _this9.salesTypeOptions[_this9.table[i].dept_sales_type]['display_name'], _this9.table[i].dept_name, _this9.table[i].referrer_user_id, _this9.table[i].referrer_name, _this9.table[i].superior_user_id, _this9.table[i].superior_name, _this9.table[i].date_joined, _this9.table[i].last_login];
          console.log(_this9.rowData);
          excelData.push(_this9.rowData);
        }
        console.log(_this9.table);
        var ws = _xlsx.default.utils.aoa_to_sheet(excelData);
        var wb = _xlsx.default.utils.book_new();
        _xlsx.default.utils.book_append_sheet(wb, ws, 'user');
        _xlsx.default.writeFile(wb, 'user.xlsx');
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 10
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAddUser: function handleAddUser() {
      var _this10 = this;
      this.user = Object.assign({}, defaultUser);
      this.dialogType = 'new';
      this.dialogVisible = true;
      // this.saleType = false
      // this.noSaleType = false
      this.getDept();
      this.$nextTick(function () {
        _this10.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(scope) {
        var _this11 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.user = Object.assign({}, scope.row); // copy obj
              console.log(this.user);
              if (!(this.user.referrer !== null)) {
                _context2.next = 7;
                break;
              }
              _context2.next = 5;
              return (0, _user.getUser)(this.user.referrer).then(function (response) {
                _this11.$set(_this11.user, 'referrer_id', response.data.user_id);
                _this11.$set(_this11.user, 'referrer_name', response.data.name);
              });
            case 5:
              _context2.next = 9;
              break;
            case 7:
              this.$set(this.user, 'referrer_id', '');
              this.$set(this.user, 'referrer_name', '');
            case 9:
              this.password = '';
              this.dialogType = 'edit';
              this.dialogVisible = true;
              this.getDept();
              this.getSuperior();
              this.$nextTick(function () {
                var that = _this11;
                that.$refs['Form'].clearValidate();
              });
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    handleDelete: function handleDelete(scope) {
      var _this12 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _user.deleteUser)(scope.row.id);
            case 2:
              // this.userList.results.splice($index, 1)
              _this12.getList();
              _this12.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(form) {
        var _this13 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this13.dialogType === 'edit';
                  delete _this13.user.referrer_id;
                  delete _this13.user.referrer_name;
                  if (isEdit) {
                    if (_this13.password !== '') {
                      _this13.user.password = _this13.password;
                    } else {
                      delete _this13.user.password;
                    }
                    // 移除api domain
                    _this13.user.avatar = _this13.user.avatar.replace(process.env.VUE_APP_BASE_API, '');
                    (0, _user.updateUser)(_this13.user.id, _this13.user).then(function (res) {
                      _this13.getList();
                      _this13.dialogVisible = false;
                      _this13.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    }).catch(function (error) {
                      console.log(2, error);
                      if (_this13.user.referrer) {
                        (0, _user.getUser)(_this13.user.referrer).then(function (response) {
                          _this13.$set(_this13.user, 'referrer_id', response.data.user_id);
                          _this13.$set(_this13.user, 'referrer_name', response.data.name);
                        });
                      }
                      console.log(_this13.user);
                    });
                  } else {
                    if (_this13.saleType && !_this13.user.home_account_name) {
                      _this13.$message({
                        message: '无匹配会员信息，请再次确认',
                        type: 'warning'
                      });
                    } else {
                      // 移除api domain
                      _this13.user.avatar = _this13.user.avatar.replace(process.env.VUE_APP_BASE_API, '');
                      (0, _user.createUser)(_this13.user).then(function (res) {
                        _this13.getList();
                        _this13.dialogVisible = false;
                        _this13.$message({
                          message: '新增成功',
                          type: 'success'
                        });
                      }).catch(function (error) {
                        console.log(2, error);
                        if (_this13.user.referrer) {
                          (0, _user.getUser)(_this13.user.referrer).then(function (response) {
                            _this13.$set(_this13.user, 'referrer_id', response.data.user_id);
                            _this13.$set(_this13.user, 'referrer_name', response.data.name);
                          });
                        }
                        console.log(_this13.user);
                      });
                    }
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};